import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    'Missing Supabase environment variables. Please check REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY'
  )
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    storageKey: 'ioag-auth',
    storage: window.localStorage,
    flowType: 'pkce', // Enhanced security with PKCE
  },
  global: {
    headers: {
      'X-Client-Info': 'ioag-webapp/1.0',
    },
  },
  db: {
    schema: 'public',
  },
  realtime: {
    params: {
      eventsPerSecond: 10,
    },
  },
})

// Enhanced error handling for Supabase operations
supabase.auth.onAuthStateChange((event, session) => {
  if (process.env.REACT_APP_ENABLE_DEBUG_LOGS === 'true') {
    console.log('Supabase auth event:', event, {
      hasSession: !!session,
      userId: session?.user?.id,
      expiresAt: session?.expires_at,
    })
  }

  // Security: Clear sensitive data on sign out
  if (event === 'SIGNED_OUT') {
    // Clear any cached user data
    localStorage.removeItem('ioag-user-cache')
    sessionStorage.clear()
  }
})

export default supabase
